import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CONTACT } from "@/data/content";
import { assetUrl } from "@/lib/assets";

const links = [
  { label: "Results", href: "#proof" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1], delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-paper/80 backdrop-blur-md border-b border-hairline" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center group">
          <img
            src={assetUrl("logo.png")}
            alt="ItsOrganic"
            className="h-7 md:h-8 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-ink/70 hover:text-ink link-underline pb-1 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={CONTACT.calendly}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-book"
          className="group inline-flex items-center gap-2 rounded-full bg-forest px-5 py-2.5 text-sm font-semibold text-white hover:bg-forestdeep transition-colors duration-300"
        >
          Book a call
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
            →
          </span>
        </a>
      </div>
    </motion.header>
  );
};
